import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import {matchAccaFactory} from './match-acca.factory';

import PALETTE_SCHEMA from './match-acca.palette-schema.yaml';

class MatchAccaFeature extends AbstractVisualFeature {
    get name() {
        return 'MatchAcca';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return matchAccaFactory(PALETTE);
    }
}

export const MatchAcca = new MatchAccaFeature(allVisuals);
